export default {
  setPreInvoices(state, invoices) {
    state.invoices = invoices;
  },
  toggleLoading(state, isLoading = false) {
    state.loading = isLoading;
  },
  setFormInvoiceField(state, invoice) {
    const { id } = invoice || {};

    state.form.table_form[id] = {
      ...(state.form.table_form[id] ? state.form.table_form[id] : ({})),
      ...invoice,
    };
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-audit/store/mutations.js